import { jsx as _jsx } from "react/jsx-runtime";
import { LinkComponentContext } from '#pplx/frontend/aether/components/link-component/LinkComponentContext.js';
export function LinkComponentProvider({ linkComponent, children, }) {
    return (_jsx(LinkComponentContext.Provider, { value: linkComponent, children: children }));
}
//# sourceMappingURL=LinkComponentProvider.js.map